module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("老师管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("奖惩机制")])], 1)], 1), _vm._v(" "), _c('div', [_c('quillEditor', {
    ref: "myQuillEditor",
    attrs: {
      "options": _vm.editorOption
    },
    on: {
      "change": _vm.textChange
    },
    model: {
      value: (_vm.formData.content),
      callback: function($$v) {
        _vm.$set(_vm.formData, "content", $$v)
      },
      expression: "formData.content"
    }
  }), _vm._v(" "), _c('el-upload', {
    ref: "upload",
    staticClass: "upload-demo",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "action": _vm.action,
      "before-upload": _vm.beforeUpload,
      "headers": _vm.headers,
      "accept": _vm.acceptType,
      "on-success": _vm.upScuccess
    }
  }, [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.fullscreenLoading),
      expression: "fullscreenLoading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "size": "small",
      "type": "primary",
      "id": "imgInput",
      "element-loading-text": "插入中,请稍候"
    }
  }, [_vm._v("点击上传")])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingInsert
    },
    on: {
      "click": _vm.saveData
    }
  }, [_vm._v("保存")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03b731ad","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/teacher/BonusAndDeduction.vue
// module id = 1612
// module chunks = 8